/* airboost-brochure-download.js
   Powers the PDP "Download Brochure" block. Shares capture state with
   popup-pincode-phone via window.DuroflexPopup (localStorage).

   Flow (2 screens, no success screen):
     Screen 1 (single screen, inline like the pincode/phone popup):
       phone → "Verify" (send OTP) → OTP boxes + "Verify OTP" (+ Resend) → verified.
       pincode stays visible. "Understand Airboost" CTA (enabled once OTP verified +
       pincode valid) DOWNLOADS the file, submits lead, → Screen 2.
     Screen 2: Name + Email (both optional) → Submit → closes.
   If pincode+phone already stored, the button downloads immediately (no popup). */
(function(){
  if (window.__duroflex_abd_booted) return;
  window.__duroflex_abd_booted = true;

  var API = {
    pincodeCheck: '/apps/sla/check',
    // OTP moved off binaryic onto the sh-dfx-tools TrustSignal service (2026-08-05).
    // Origin-gated + browser-only: never call these server-side or with credentials.
    sendOtp:   'https://sendotp-y4njpney2q-el.a.run.app',
    verifyOtp: 'https://verifyotp-y4njpney2q-el.a.run.app',
    otpBrand:  'DFX',
    // Revocation handle, not authentication: readable in View Source.
    otpApiKey: 'TOULiD7aT2gXMtL-RRWaBL2Z-KjaJjRj5zFEeqjoCQQ',
    googleLeadCapture:    'https://script.google.com/macros/s/AKfycby9jBb2p_yIXTYPavHWwllQJp6QwIm9XwFt8M2xtEryLjQ4wFx-juS6usugup1r7UXK/exec',
    salesforceLeadCapture:'https://dfxstorelocatorapi.azurewebsites.net/api/SleepQuiz/LeadCreation',
    salesforceLeadKey:    'TGVhZENyZWF0aW9uU2xlZXBxdWl6',
    // sh-dfx-tools lead store. Runs ALONGSIDE Salesforce + the Sheet; strict payload
    // (unknown keys are a hard 400) so it gets its own builder.
    dfxLeadCapture:       'https://asia-south1-sh-dfx-tools.cloudfunctions.net/createLead',
    dfxLeadKey:           '37438c7b9d2819932d7783e5f0c4169b0efcf2cdd674f4d1'
  };
  var RESEND_SECONDS = 30;
  var PHONE_RE = /^[6-9]\d{9}$/;
  var PIN_RE = /^\d{6}$/;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function D(){ return window.DuroflexPopup || null; }

  function triggerDownload(url, filename){
    if (!url) return;
    try {
      var a = document.createElement('a');
      a.href = url;
      if (filename) a.download = filename;
      a.rel = 'noopener';
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch(e){ try { window.open(url, '_blank'); } catch(_){} }
  }

  // ----- MoEngage -----
  // Same bridge the quick-login popup and quiz use (assets/dfx-moengage.js): the S2S
  // transition endpoint refuses browser CORS, so events go through the Web SDK the
  // MoEngage app embed already loads. Own attribute prefix (bd_) and own event names
  // so this surface segments apart from quick_login / sleep_quiz.
  function bdSplitName(full){
    var parts = String(full || '').trim().split(/\s+/).filter(Boolean);
    return { first: parts.shift() || '', last: parts.join(' ') };
  }

  // Capped at the five agreed fields (2026-08-20). Both events still fire; only
  // the attributes shrank. Kept for reference, no longer sent:
  //   profile : bd_store_name, bd_consent_status, bd_popup_brand,
  //             bd_popup_channel, bd_is_website_lead, bd_lifecycle_stage
  //   event   : baseEventAttrs() -> source, device_type, browser, os, url,
  //             utm_source, utm_medium, utm_campaign
  //             plus popup_type: 'brochure_download' and verification_status
  //   bd_pincode is now the plain `pincode` key.
  function bdMoeFire(action, phone, details){
    if (!window.DFXMoEngage || !phone) return;
    var d = D();
    details = details || {};
    var f = {
      phone: phone,
      pincode: (d && d.getPincode && d.getPincode()) || '',
      name: details.name || '',
      email: details.email || ''
    };
    try {
      window.DFXMoEngage.emit(phone, window.DFXMoEngage.leadProfile(f), action, window.DFXMoEngage.leadEventAttrs(f));
    } catch(e){ if (window.console) console.warn('[abd] MoEngage emit failed', e); }
  }

  // ----- sh-dfx-tools lead -----
  function bdPostDfxLead(phone, stage, details){
    if (!API.dfxLeadCapture || !phone) return Promise.resolve(null);
    var d = D();
    var pinData = (d && d.getPincodeData && d.getPincodeData()) || {};
    var attr = (d && d.getAttribution && d.getAttribution()) || {};
    var gclid = (d && d.getGclid && d.getGclid()) || attr.gclid || null;
    var pincode = (d && d.getPincode && d.getPincode()) || '';
    var isProduct = location.pathname.indexOf('/products/') !== -1;
    var productTitle = ((document.querySelector('[data-product-title]') || document.querySelector('.product__title') || {}).textContent || '').trim();
    var nm = ((details && details.name) || '').trim();
    var em = ((details && details.email) || '').trim();
    var now = new Date().toISOString();

    var payload = {
      phone: phone,
      brand: 'DFX',
      lead_status: (stage === 'post_otp' || stage === 'details_submitted') ? 'otp_verified' : 'unverified',
      event_timestamp: now,
      attribution: {
        source: 'pdp_brochure_download',
        event: 'brochure_download',
        lead_stage: stage,
        page_type: isProduct ? 'product' : 'page',
        page_url: location.href,
        referrer: /^https?:\/\//.test(document.referrer || '') ? document.referrer : null,
        utm_source: attr.utm_source || null,
        utm_medium: attr.utm_medium || null,
        utm_campaign: attr.utm_campaign || null,
        gclid: gclid || null
      },
      // The brochure sheet shows a passive notice, not a tick-box.
      consent: {
        marketing: true,
        channels: ['sms', 'whatsapp'],
        granted_at: now,
        method: 'notice',
        ui_surface: 'pdp_brochure_modal',
        locale: 'en-IN'
      }
    };
    if (nm) payload.name = nm.slice(0, 128);
    if (em) payload.email = em.slice(0, 254);
    // Exactly 6 digits or the whole lead 400s.
    if (/^\d{6}$/.test(pincode)) payload.pincode = pincode;
    if (pinData.city) payload.city = String(pinData.city).slice(0, 128);
    if (pinData.storename) payload.store = String(pinData.storename).slice(0, 128);
    if (productTitle) {
      payload.products = [{ name: productTitle.slice(0, 256) }];
      if (isProduct) payload.products[0].url = location.pathname;
    }

    return fetch(API.dfxLeadCapture, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-API-Key': API.dfxLeadKey },
      body: JSON.stringify(payload),
      keepalive: true
    }).then(function(r){ return r.text().then(function(t){
      var parsed = {};
      try { parsed = t ? JSON.parse(t) : {}; } catch(e){ parsed = { raw: t }; }
      if (!r.ok || parsed.success !== true) throw new Error('dfx_lead HTTP ' + r.status + ': ' + t);
      return parsed;
    }); });
  }

  // ----- Lead capture (compact replica of popup-pincode-phone submitLead) -----
  var leadSent = {};
  function submitLead(phone, stage, details){
    var d = D();
    if (!d || !phone) return;
    stage = stage || 'post_otp';
    details = details || {};
    var pinData = (d.getPincodeData && d.getPincodeData()) || {};
    var attr = (d.getAttribution && d.getAttribution()) || {};
    var gclid = (d.getGclid && d.getGclid()) || attr.gclid || null;
    var productTitle = (document.querySelector('[data-product-title]') || document.querySelector('.product__title') || {}).textContent || '';
    productTitle = productTitle.trim();
    var productUrl = location.href.indexOf('/products/') !== -1 ? location.href : '';
    var pincode = (d.getPincode && d.getPincode()) || '';
    var sid = (d.getSessionId && d.getSessionId()) || '';
    var name = (details.name || '').trim() || 'DFX_User';
    var email = (details.email || '').trim();
    var dedupe = phone + '|' + pincode + '|' + stage;
    if (leadSent[dedupe]) return;
    leadSent[dedupe] = true;

    // Payload shape is a KEY-FOR-KEY replica of popup-pincode-phone.js submitLead.
    // The Salesforce LeadCreation endpoint rejects partial bodies, so every field
    // the popup sends must be present here too — including the empty/null ones.
    var payload = {
      name: name,
      phone: phone,
      email: email,

      pincode: pincode,
      city: pinData.city || '',
      channel: 'Website',
      event: 'download_brochure',
      brand: 'Duroflex',
      product_name: "",
      recommendation1: productUrl,
      recommendation2: '',
      recommendation3: '',
      recommendation4: '',
      timestamp: new Date().toISOString(),
      Page_referrer: location.href,
      Questions_answer_array: '',
      Products_recommendation_array: productUrl,
      User_Agent: navigator.userAgent,
      Store_Name: pinData.storename || '',
      Employee_Code: '',
      Tag: 'new_lead',
      lead_stage: stage,
      lead_id: [sid, phone, pincode].join('|'),
      otp_status: (stage === 'post_otp' || stage === 'details_submitted') ? 'verified' : 'pending',

      Event: 'Download_Brochure',
      Name: name,
      Phone: phone,
      Email: email || null,

      Pincode: pincode || null,
      City: pinData.city || null,
      Channel: null,
      Brand: 'Duroflex',
      Store_Name: pinData.storename || null,
      Preferred_Date: null,
      Time_Slot: null,
      Recommendation1: null,
      Recommendation2: null,
      Recommendation3: null,
      Recommendation4: null,
      Products_Recommendation_Array: null,
      Questions_Answer_Array: null,
      Timestamp: new Date().toISOString(),
      Page_Referrer: location.origin + location.pathname,
      User_Agent: navigator.userAgent,
      UTM_AirBoost: attr.utm_campaign || null,
      UTM_Source_AirBoost: attr.utm_source || null,
      UTM_Medium: attr.utm_medium || null,
      GCL_ID: gclid || null
    };
    // Same response handling as the popup: a non-2xx or a non-success status body
    // is an error, so failures surface in tracking instead of being swallowed.
    function parseLeadResponse(target, r){
      return r.text().then(function(text){
        var parsed = {};
        try { parsed = text ? JSON.parse(text) : {}; } catch(e) { parsed = { raw: text }; }
        if (!r.ok) throw new Error(target + ' HTTP ' + r.status + ': ' + text);
        if (parsed.status && parsed.status !== 'success') {
          throw new Error(target + ' status ' + parsed.status + (parsed.message ? ': ' + parsed.message : ''));
        }
        return parsed;
      });
    }
    function postLeadTarget(target, url, headers){
      if (!url) return Promise.resolve(null);
      return fetch(url, { method:'POST', headers: headers, body: JSON.stringify(payload), keepalive:true })
        .then(function(r){ return parseLeadResponse(target, r); })
        .then(function(data){
          var oid = (data && (data.opportunityId || data.opportunity_id || data.sfsc)) || null;
          if (d.track) d.track('qlp_lead_submitted_' + target, { stage: stage, target: target, opportunity_id: oid, source: 'brochure_download' });
          return data;
        })
        .catch(function(err){
          if (d.track) d.track('qlp_lead_submit_failed_' + target, { stage: stage, target: target, error: String(err), source: 'brochure_download' });
          throw err;
        });
    }
    try {
      // MoEngage fires here rather than at the call sites: submitLead is invoked
      // twice for post_otp (verify + CTA) and the leadSent guard above means this
      // point is reached exactly once per stage.
      if (stage === 'details_submitted') {
        // bdSplitName() is left defined but unused: the cap sends the name whole.
        bdMoeFire('Brochure Download - Profile Submitted', phone, { name: (details.name || ''), email: email });
      } else {
        bdMoeFire('Brochure Download - OTP Verified', phone);
      }
      Promise.allSettled([
        postLeadTarget('google_sheet', API.googleLeadCapture, { 'Content-Type':'text/plain' }),
        postLeadTarget('salesforce', API.salesforceLeadCapture, { 'Content-Type':'application/json', 'X-Api-Key': API.salesforceLeadKey }),
        bdPostDfxLead(phone, stage, { name: (details.name || ''), email: email })
          .then(function(data){ if (d.track) d.track('qlp_lead_submitted_dfx_lead', { stage: stage, lead_id: (data && data.lead_id) || null, source: 'brochure_download' }); return data; })
          .catch(function(err){ if (d.track) d.track('qlp_lead_submit_failed_dfx_lead', { stage: stage, error: String(err), source: 'brochure_download' }); throw err; })
      ]).then(function(results){
        var failures = results.filter(function(r){ return r.status === 'rejected'; });
        if (failures.length) {
          // Allow a retry of this stage once a target has failed.
          leadSent[dedupe] = false;
          if (d.track) d.track('qlp_lead_submit_failed', { stage: stage, error: failures.length + ' lead target(s) failed', source: 'brochure_download' });
          return;
        }
        if (d.track) d.track('qlp_lead_submitted', { stage: stage, targets:'google_sheet,salesforce,dfx_lead', source:'brochure_download' });
      });
    } catch(e){
      leadSent[dedupe] = false;
    }
  }

  // Enrich pincode data (non-blocking) — mirrors validatePincode's persistence.
  function enrichPincode(pin){
    var d = D(); if (!d) return;
    d.setPincode(pin);
    // request for the variant selected right now on a product page (assets/dfx-delivery.js), else product-neutral
    var body = window.DfxDelivery ? window.DfxDelivery.request(pin, { qty: 1 })
      : { l1_product_group: 'ALL', l5_product_group: '', l6_product_group: '', pincode: pin, qty: 1, sku: '', combo_sku: '' };
    fetch(API.pincodeCheck, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body) })
      .then(function(r){ return r.json(); })
      .then(function(data){
        d.setPincode(pin, {
          pincode: pin, serviceable: !!(data && data.success),
          city: (data && data.city) || '', estimated_delivery_date: (data && data.estimated_delivery_date) || '',
          storename: (data && data.Storename) || '', address: (data && data.Address) || ''
        });
      }).catch(function(){});
  }

  // Geolocate → reverse-geocode helper shared by the manual button and the
  // silent auto-fill. Calls onPin('') when no valid 6-digit postcode resolves;
  // geolocation failures (incl. permission denied) go to onGeoErr.
  function geoLocatePincode(onPin, onGeoErr){
    navigator.geolocation.getCurrentPosition(function(pos){
      fetch('https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=' + pos.coords.latitude + '&lon=' + pos.coords.longitude)
        .then(function(r){ return r.json(); })
        .then(function(data){
          var pin = data && data.address && data.address.postcode ? String(data.address.postcode).replace(/\D/g,'').slice(0,6) : '';
          onPin(PIN_RE.test(pin) ? pin : '');
        })
        .catch(function(err){ onPin('', err); });
    }, onGeoErr, { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 });
  }

  // Both helpers keep their boolean contract; the server's own message is stashed
  // here so callers can show "4 tries left" or an origin error instead of a flat
  // "Invalid OTP". Read it immediately after the promise settles.
  var lastOtpError = '';
  // A wrong code answers HTTP 400 with a JSON body and fetch does not reject on
  // 4xx — read the body either way, never branch on r.ok.
  function readJson(r){ return r.text().then(function(t){ try { return JSON.parse(t); } catch(e){ return { success: r.ok }; } }); }

  function sendOtp(phone){
    lastOtpError = '';
    return fetch(API.sendOtp, { method:'POST', headers:{'Content-Type':'application/json','X-API-Key':API.otpApiKey}, body: JSON.stringify({ phone: phone, brand: API.otpBrand }) })
      .then(readJson)
      .then(function(data){
        if (!data || data.success !== true) { lastOtpError = (data && data.message) || ''; return false; }
        // Service owns the cooldown — startResend() reads this on its next call.
        RESEND_SECONDS = parseInt(data.resendAfterSeconds, 10) || RESEND_SECONDS;
        return true;
      })
      .catch(function(){ return false; });
  }
  function verifyOtp(phone, otp){
    lastOtpError = '';
    return fetch(API.verifyOtp, { method:'POST', headers:{'Content-Type':'application/json','X-API-Key':API.otpApiKey}, body: JSON.stringify({ phone: phone, otp: otp, brand: API.otpBrand }) })
      .then(readJson)
      .then(function(data){
        if (data && data.verified === true) return true;
        var msg = (data && data.message) || '';
        var left = data && data.attemptsRemaining;
        if (typeof left === 'number' && left > 0) msg += ' ' + left + (left === 1 ? ' try left.' : ' tries left.');
        lastOtpError = msg;
        return false;
      })
      .catch(function(){ return false; });
  }

  function initRoot(root){
    var d = D();
    var fileUrl  = root.dataset.fileUrl || '';
    var fileName = root.dataset.fileName || '';
    var popupId  = root.dataset.popupId || root.id;

    var steps = {};
    root.querySelectorAll('.abd-step').forEach(function(el){ steps[el.dataset.step] = el; });
    var phoneField = root.querySelector('[data-abd-phone-field]');
    var phoneInput = root.querySelector('[data-abd-phone]');
    var sendOtpBtn = root.querySelector('[data-abd-send-otp]');
    var otpWrap    = root.querySelector('[data-abd-otp-wrap]');
    var otpBoxes   = Array.prototype.slice.call(root.querySelectorAll('.abd-otp-box'));
    var verifyOtpBtn = root.querySelector('[data-abd-verify-otp]');
    var resendBtn  = root.querySelector('[data-abd-resend]');
    var otpErrEl   = root.querySelector('[data-abd-err-otp]');
    var pinInput   = root.querySelector('[data-abd-pincode]');
    var errEl      = root.querySelector('[data-abd-err]');
    var geoBtn     = root.querySelector('[data-abd-geo]');
    var geoStatus  = root.querySelector('[data-abd-geo-status]');
    var ctaBtn     = root.querySelector('[data-abd-cta]');
    var nameInput  = root.querySelector('[data-abd-name]');
    var emailInput = root.querySelector('[data-abd-email]');
    var submitBtn  = root.querySelector('[data-abd-submit]');
    var detailsErr = root.querySelector('[data-abd-err-details]');
    var resendOrig = resendBtn ? resendBtn.textContent.trim() : 'Resend OTP';
    var resendTick = null;

    var otpSent = false;
    var phoneVerified = false;
    var verifiedPhone = '';

    function setStep(name){
      Object.keys(steps).forEach(function(k){ steps[k].hidden = (k !== name); });
    }
    // Hide any Quick Login (pincode/phone) popup already open so the two don't stack.
    function hideQuickLogin(){
      document.querySelectorAll('.popup-pp').forEach(function(el){
        el.classList.remove('popup-pp--visible');
        el.classList.add('popup-pp--hidden');
      });
      document.body.classList.remove('popup-pp-open');
    }
    function open(){
      window.__duroflexBrochureOpen = true;
      hideQuickLogin();
      // Also tell the quick-login popup to stand down properly — hiding its DOM
      // alone leaves it thinking it is still open, and a later trigger re-shows it.
      try { window.dispatchEvent(new CustomEvent('duroflex:brochure-opened')); } catch(e){}
      root.hidden = false;
      root.classList.add('is-open');
      if (d) {
        if (phoneInput && d.getPhone()) phoneInput.value = d.getPhone();
        if (pinInput && d.getPincode()) pinInput.value = d.getPincode();
      }
      setStep('form');
      syncSendBtn(); syncCta();
      // If location permission was already granted, silently fill the pincode.
      autoFillPincodeFromLocation();
      if (d && d.track) d.track('qlp_brochure_popup_viewed', { popup_id: popupId });
    }
    function close(){
      window.__duroflexBrochureOpen = false;
      try { window.dispatchEvent(new CustomEvent('duroflex:brochure-closed')); } catch(e){}
      root.classList.remove('is-open');
      if (resendTick) { clearInterval(resendTick); resendTick = null; }
      setTimeout(function(){ if (!root.classList.contains('is-open')) root.hidden = true; }, 320);
    }
    function setErr(el, msg){ if (el) el.textContent = msg || ''; }

    // ----- Phone + inline Verify (send OTP) -----
    if (phoneInput) phoneInput.addEventListener('input', function(){
      this.value = this.value.replace(/\D/g,'');
      // Editing a verified phone resets verification.
      if (phoneVerified && this.value.trim() !== verifiedPhone) resetVerification();
      syncSendBtn(); syncCta();
    });
    function syncSendBtn(){
      if (!sendOtpBtn) return;
      if (phoneVerified) { sendOtpBtn.hidden = true; return; }
      var valid = PHONE_RE.test((phoneInput.value||'').trim());
      sendOtpBtn.hidden = otpSent || !valid;
      sendOtpBtn.disabled = !valid;
    }
    function resetVerification(){
      otpSent = false; phoneVerified = false; verifiedPhone = '';
      if (otpWrap) otpWrap.hidden = true;
      if (phoneField) phoneField.classList.remove('is-verified');
      if (phoneInput) phoneInput.readOnly = false;
      otpBoxes.forEach(function(b){ b.value=''; b.disabled=false; });
      if (verifyOtpBtn) verifyOtpBtn.disabled = true;
      setErr(otpErrEl, '');
      if (resendTick) { clearInterval(resendTick); resendTick = null; }
      if (resendBtn) { resendBtn.disabled = false; resendBtn.textContent = resendOrig; }
    }
    if (sendOtpBtn) sendOtpBtn.addEventListener('click', function(){
      if (sendOtpBtn.disabled) return;
      var phone = (phoneInput.value||'').trim();
      if (!PHONE_RE.test(phone)) return;
      sendOtpBtn.disabled = true;
      if (d && d.track) d.track('qlp_brochure_otp_send_attempt', { popup_id: popupId });
      sendOtp(phone).then(function(ok){
        sendOtpBtn.disabled = false;
        if (!ok) { setErr(otpErrEl, lastOtpError || 'Could not send OTP, please try again'); otpWrap.hidden = false; return; }
        otpSent = true;
        sendOtpBtn.hidden = true;
        otpWrap.hidden = false;
        clearOtp();
        startResend();
        var first = otpBoxes[0]; if (first) first.focus();
      });
    });

    // ----- OTP boxes -----
    function otpValue(){ return otpBoxes.map(function(b){ return b.value; }).join(''); }
    function clearOtp(){ otpBoxes.forEach(function(b){ b.value=''; }); syncVerifyOtp(); setErr(otpErrEl,''); }
    function syncVerifyOtp(){ if (verifyOtpBtn) verifyOtpBtn.disabled = !/^\d{6}$/.test(otpValue()); }
    otpBoxes.forEach(function(box, i){
      box.addEventListener('input', function(){
        box.value = box.value.replace(/\D/g,'').slice(0,1);
        if (box.value && otpBoxes[i+1]) otpBoxes[i+1].focus();
        syncVerifyOtp();
      });
      box.addEventListener('keydown', function(e){
        if (e.key === 'Backspace' && !box.value && otpBoxes[i-1]) otpBoxes[i-1].focus();
      });
      box.addEventListener('paste', function(e){
        e.preventDefault();
        var digits = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g,'').slice(0, otpBoxes.length);
        for (var j=0; j<digits.length; j++) if (otpBoxes[j]) otpBoxes[j].value = digits[j];
        var next = otpBoxes[Math.min(digits.length, otpBoxes.length-1)]; if (next) next.focus();
        syncVerifyOtp();
      });
    });
    if (verifyOtpBtn) verifyOtpBtn.addEventListener('click', function(){
      if (verifyOtpBtn.disabled) return;
      var phone = (phoneInput.value||'').trim();
      var otp = otpValue();
      if (!/^\d{6}$/.test(otp)) { setErr(otpErrEl, 'Enter the OTP sent to your phone'); return; }
      verifyOtpBtn.disabled = true;
      setErr(otpErrEl, '');
      verifyOtp(phone, otp).then(function(ok){
        if (!ok) { setErr(otpErrEl, lastOtpError || 'Invalid OTP, please try again'); syncVerifyOtp(); return; }
        phoneVerified = true; verifiedPhone = phone;
        if (d) d.setPhone(phone, { otpVerified: true });
        if (phoneField) phoneField.classList.add('is-verified');
        if (phoneInput) phoneInput.readOnly = true;
        otpBoxes.forEach(function(b){ b.disabled = true; });
        verifyOtpBtn.hidden = true;
        if (resendBtn) resendBtn.hidden = true;
        if (resendTick) { clearInterval(resendTick); resendTick = null; }
        if (d && d.track) d.track('qlp_brochure_otp_verified', { popup_id: popupId });
        submitLead(phone, 'post_otp');
        syncCta();
      });
    });

    // ----- Resend -----
    function startResend(){
      if (!resendBtn) return;
      var remaining = RESEND_SECONDS;
      resendBtn.disabled = true;
      resendBtn.textContent = resendOrig + ' (' + remaining + 's)';
      if (resendTick) clearInterval(resendTick);
      resendTick = setInterval(function(){
        remaining -= 1;
        if (remaining <= 0) { clearInterval(resendTick); resendTick = null; resendBtn.disabled = false; resendBtn.textContent = resendOrig; return; }
        resendBtn.textContent = resendOrig + ' (' + remaining + 's)';
      }, 1000);
    }
    if (resendBtn) resendBtn.addEventListener('click', function(){
      if (resendBtn.disabled) return;
      var phone = (phoneInput.value||'').trim();
      if (!PHONE_RE.test(phone)) return;
      if (d && d.track) d.track('qlp_brochure_otp_resent', { popup_id: popupId });
      sendOtp(phone).then(function(ok){ if (ok) startResend(); });
    });

    // Silent auto-fill. Never triggers the browser prompt itself, and only ever
    // writes into an empty pincode input. Three sources, cheapest first:
    //   1. localStorage `duroflex_pincode` - the one pincode store shared with the PDP
    //   2. `duroflex:pincode-detected` — the PDP resolved a pincode while we're open
    //   3. the geolocation permission: already granted, OR granted later. The
    //      Permissions API `onchange` fires the moment the shopper hits Allow on
    //      the PDP's prompt, so this popup fills itself while it is on screen.
    var geoAutoTried = false;
    var geoWatching = false;
    function readPincodeCookie(){
      // Name kept for the callers; the source is now localStorage duroflex_pincode
      // (getPincode migrates a legacy user_pincode cookie into it once).
      var pin = ''; try { pin = (d && d.getPincode) ? (d.getPincode() || '') : ''; } catch(e){}
      return /^\d{6}$/.test(pin) ? pin : '';
    }
    function fillDetectedPincode(pin, source){
      if (!pinInput || !PIN_RE.test(pin || '')) return false;
      if ((pinInput.value || '').trim()) return false; // user typed one meanwhile
      pinInput.value = pin;
      setErr(errEl, '');
      syncCta();
      if (geoStatus) { geoStatus.textContent = 'Pincode filled from your location'; geoStatus.style.color = '#5ad19a'; }
      if (d && d.track) d.track('qlp_fetch_location_auto_success', { pincode: pin, source: source, popup_id: popupId });
      return true;
    }
    function runGeoAutoFill(source){
      if (geoAutoTried) return;
      if (!pinInput || (pinInput.value || '').trim()) return;
      geoAutoTried = true; // one lookup at a time — keep Nominatim usage polite
      if (d && d.track) d.track('qlp_fetch_location_auto', { popup_id: popupId, source: source });
      geoLocatePincode(function(pin){
        geoAutoTried = false;
        if (!pin) { if (d && d.track) d.track('qlp_fetch_location_auto_failed', { reason: 'no_postcode', source: 'brochure_download' }); return; }
        fillDetectedPincode(pin, source);
      }, function(err){
        geoAutoTried = false;
        if (d && d.track) d.track('qlp_fetch_location_auto_failed', { reason: 'geo_error', error: String(err && err.message), source: 'brochure_download' });
      });
    }
    function autoFillPincodeFromLocation(){
      if (!pinInput || (pinInput.value || '').trim()) return; // already have a pincode
      if (fillDetectedPincode(readPincodeCookie(), 'cookie')) return;
      if (!navigator.geolocation || !navigator.permissions || !navigator.permissions.query) return;
      if (geoWatching) return;
      geoWatching = true;
      try {
        navigator.permissions.query({ name: 'geolocation' }).then(function(res){
          if (!res) return;
          if (res.state === 'granted') runGeoAutoFill('permission_granted');
          res.onchange = function(){ if (res.state === 'granted') runGeoAutoFill('permission_change'); };
        }).catch(function(){ geoWatching = false; });
      } catch(e){ geoWatching = false; }
    }
    // PDP detect resolved a pincode while this popup is up → mirror it in.
    window.addEventListener('duroflex:pincode-detected', function(e){
      if (!root.classList.contains('is-open')) return;
      fillDetectedPincode(e && e.detail && e.detail.pincode, 'pdp_detect');
    });

    // ----- Fetch My Location → reverse-geocode to a pincode, fill the input ONLY.
    // Mirrors popup-pincode-phone: no persist, no validate, no auto-submit.
    if (geoBtn) geoBtn.addEventListener('click', function(){
      var span = geoBtn.querySelector('span');
      var origLabel = span ? span.textContent : '';
      function done(msg, isErr){
        if (geoStatus) { geoStatus.textContent = msg || ''; geoStatus.style.color = isErr ? '#ff8f8f' : '#5ad19a'; }
        geoBtn.disabled = false;
        if (span) span.textContent = origLabel;
      }
      if (!navigator.geolocation) { done('Location not supported on this device', true); return; }
      geoBtn.disabled = true;
      if (span) span.textContent = 'Locating…';
      if (geoStatus) { geoStatus.textContent = 'Detecting your location…'; geoStatus.style.color = '#9fb2ce'; }
      if (d && d.track) d.track('qlp_fetch_location_clicked', { popup_id: popupId, source: 'brochure_download' });
      geoLocatePincode(function(pin, err){
        if (pin) {
          pinInput.value = pin;      // populate input only
          setErr(errEl, '');
          syncCta();
          done('Pincode filled from your location', false);
          if (d && d.track) d.track('qlp_fetch_location_success', { pincode: pin, source: 'brochure_download' });
        } else {
          done('Could not detect a pincode, please enter it', true);
          if (d && d.track) d.track('qlp_fetch_location_failed', err ? { error: String(err), source: 'brochure_download' } : { reason: 'no_postcode', source: 'brochure_download' });
        }
      }, function(err){
        done('Location permission denied, please enter pincode', true);
        if (d && d.track) d.track('qlp_fetch_location_failed', { reason: 'permission', error: String(err && err.message), source: 'brochure_download' });
      });
    });

    // ----- Pincode + CTA (Understand Airboost = download) -----
    if (pinInput) pinInput.addEventListener('input', function(){ this.value = this.value.replace(/\D/g,''); setErr(errEl,''); if (geoStatus) geoStatus.textContent=''; syncCta(); });
    function syncCta(){
      if (!ctaBtn) return;
      var pinOk = PIN_RE.test((pinInput.value||'').trim());
      ctaBtn.disabled = !(phoneVerified && pinOk);
    }
    if (ctaBtn) ctaBtn.addEventListener('click', function(){
      if (ctaBtn.disabled) return;
      var phone = (phoneInput.value||'').trim();
      var pin   = (pinInput.value||'').trim();
      if (!phoneVerified) { setErr(errEl, 'Please verify your phone number'); return; }
      if (!PIN_RE.test(pin)) { setErr(errEl, 'Enter a valid 6-digit pincode'); return; }
      setErr(errEl, '');
      enrichPincode(pin);
      submitLead(phone, 'post_otp');
      if (d && d.track) d.track('qlp_brochure_download', { popup_id: popupId });
      triggerDownload(fileUrl, fileName);
      setStep('details');
      if (nameInput) nameInput.focus();
    });

    // ----- Screen 2: name + email (optional) → submit → close -----
    if (submitBtn) submitBtn.addEventListener('click', function(){
      var nm = (nameInput && nameInput.value || '').trim();
      var em = (emailInput && emailInput.value || '').trim();
      if (em && !EMAIL_RE.test(em)) { setErr(detailsErr, 'Please enter a valid email'); return; }
      setErr(detailsErr, '');
      var phone = (phoneInput.value||'').trim() || (d && d.getPhone && d.getPhone()) || '';
      if (nm || em) {
        submitLead(phone, 'details_submitted', { name: nm, email: em });
        if (d && d.track) d.track('qlp_brochure_details_submitted', { popup_id: popupId, has_email: !!em });
      }
      close();
    });

    // ----- Close affordances -----
    root.querySelectorAll('[data-abd-close]').forEach(function(el){ el.addEventListener('click', close); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

    // ----- Trigger buttons -----
    document.querySelectorAll('[data-abd-open="' + root.id + '"]').forEach(function(btn){
      btn.addEventListener('click', function(){
        // Already captured (pincode + phone stored) → download immediately, no popup.
        if (d && d.getPincode && d.getPhone && d.getPincode() && d.getPhone()) {
          if (d.track) d.track('qlp_brochure_download_direct', { popup_id: popupId });
          triggerDownload(fileUrl, fileName);
          return;
        }
        open();
      });
    });
  }

  function boot(){ document.querySelectorAll('.abd-root').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
